import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import { TOI_IMAGE_DOMAIN } from './../../constants';
import { onError, createImgUrl } from './utils';

class Image extends React.PureComponent {
  constructor() {
    super();
    this.state = {};
    this.imgRef = React.createRef();
  }

  render() {
    const { stateSrc } = this.state;
    const { offsetVertical = 0 } = this.props;
    const {
      msid,
      imgsize,
      width,
      resizemode,
      height,
      placeHolderSrc,
      placeholderMsid,
      lazyload,
      addFetchPriorityHighAttribute,
      hoveredSlikeId,
      hoveredSlikeIndex,
      gaIndex,
      isNotThumb,
    } = this.props;
    let src = '';
    const safePlaceholder = `${TOI_IMAGE_DOMAIN}/photo/47529300.cms`;
    const fetchPriorityObj = addFetchPriorityHighAttribute
      ? { fetchPriority: 'high' }
      : {};
    if (msid && isNotThumb) {
      src = createImgUrl(imgsize, msid, width, resizemode, height, '', true);
    } else if (msid) {
      src = createImgUrl(imgsize, msid, width, resizemode, height);
    } else {
      src = safePlaceholder;
    }
    if (this.props.src) {
      src = this.props.src;
    }
    const placeHolderSrcUrl =
      placeHolderSrc ||
      (placeholderMsid
        ? createImgUrl(imgsize, placeholderMsid, width, resizemode, height)
        : safePlaceholder);
    const reducer = (accumulator, currentValue) =>
      Object.assign(accumulator, { [currentValue[0]]: currentValue[1] });

    // retain props to be passed to the img node
    const lowerCaseProps = Object.entries(this.props)
      .map(item => {
        if (
          !(
            item[0] === 'src' ||
            item[0] === 'lazyload' ||
            item[0] === 'onClick' ||
            item[0] === 'onError' ||
            item[0] === 'onLoad' ||
            item[0] === 'altTitle' ||
            item[0] === 'className'
          )
        ) {
          return [item[0].toLowerCase(), item[1]];
        }
        return undefined;
      })
      .filter(item => item)
      .reduce(reducer, {});

    if (!lazyload) {
      return (
        <>
          {gaIndex &&
            hoveredSlikeId &&
            this.props.slikeId &&
            hoveredSlikeId === this.props.slikeId &&
            gaIndex === hoveredSlikeIndex && (
              <video
                ref={this.imgRef}
                src={`https://tvid.in/r/vp.${this.props.slikeId}.mp4`}
                width="100%"
                height="100%"
                autoPlay
                muted
                loop
                playsInline
                poster={stateSrc || placeHolderSrcUrl}
              />
            )}
          <img
            src={src}
            {...lowerCaseProps}
            alt={this.props.altTitle}
            onError={this.props.onError || onError}
            {...(this.props.onLoad ? { onLoad: this.props.onLoad } : undefined)}
            onClick={this.props.onClick}
            className={this.props.className}
            {...fetchPriorityObj}
          />
        </>
      );
    }

    return (
      <>
        {gaIndex &&
          hoveredSlikeId &&
          this.props.slikeId &&
          hoveredSlikeId === this.props.slikeId &&
          gaIndex === hoveredSlikeIndex && (
            <video
              ref={this.imgRef}
              src={`https://tvid.in/r/vp.${this.props.slikeId}.mp4`}
              width="100%"
              height="100%"
              autoPlay
              muted
              loop
              playsInline
              poster={stateSrc || placeHolderSrcUrl}
            />
          )}
        <img
          alt={this.props.altTitle}
          {...lowerCaseProps}
          src={stateSrc || placeHolderSrcUrl}
          onError={this.props.onError || onError}
          onClick={this.props.onClick}
          className={this.props.className}
        />

        <LazyLoad
          offsetVertical={offsetVertical}
          debounce={false}
          onContentVisible={() => {
            this.setState({ stateSrc: src });
          }}
          height="1px"
        >
          <></>
        </LazyLoad>
      </>
    );
  }
}
Image.propTypes = {
  offsetVertical: PropTypes.number,
  msid: PropTypes.string,
  imgsize: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resizemode: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  placeHolderSrc: PropTypes.string,
  placeholderMsid: PropTypes.string,
  src: PropTypes.string,
  lazyload: PropTypes.bool,
  type: PropTypes.string,
  altTitle: PropTypes.string,
  onClick: PropTypes.func,
  addFetchPriorityHighAttribute: PropTypes.bool,
  hoveredSlikeId: PropTypes.string,
  hoveredSlikeIndex: PropTypes.string,
  gaIndex: PropTypes.string,
};
Image.defaultProps = {
  imgsize: '11111111',
  width: undefined,
  height: undefined,
  hoveredSlikeId: '',
  hoveredSlikeIndex: '',
  gaIndex: '',
  resizemode: 4,
  title: '',
  offsetVertical: 0,
  placeHolderSrc: '',
  placeholderMsid: '47529300',
  src: '',
  lazyload: false,
  msid: '',
  type: 'thumb',
  altTitle: '',
  onClick: () => {},
  addFetchPriorityHighAttribute: false,
};
export default Image;
